import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPlacements } from "./placements";
import { Placement } from "src/types/Placement";
import Fuse from "fuse.js";
import { setConfig } from "./config";
import { getPlacementProprties } from "src/services/searchIndex";

export type Result = {
  isSearching: boolean;
  text: string;
  placementIDs: string[];
};
export type SearchSliceType = {
  result: Result;
  placements: Placement[];
  placementProperties: string[];
};
const initialState: SearchSliceType = {
  result: { isSearching: false, text: "", placementIDs: [] },
  placements: [],
  placementProperties: [],
};

// WARNING!!! You MUST turn off StrictMode or the map placement markers will persist.
const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    searchPlacements: (state, action: PayloadAction<string>) => {
      const fuseOptions = {
        keys: ["name", ...state.placementProperties],
        threshold: 0.2,
      };

      const flattenedPlacements = state.placements.map(({ details, ...x }) => ({
        ...x,
        ...{ ...details },
      }));

      const fuse = new Fuse(flattenedPlacements, fuseOptions);

      return {
        ...state,
        result: {
          isSearching: false,
          text: action.payload,
          placementIDs: action.payload
            ? fuse.search(action.payload).map((result) => result.item.id)
            : state.placements.map((x) => x.id),
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPlacements.fulfilled, (state, action) => {
      return {
        result: {
          isSearching: false,
          text: "",
          placementIDs: action.payload.map((x) => x.id),
        },
        placements: action.payload,
        placementProperties: state.placementProperties,
      };
    });
    builder.addCase(setConfig, (state, action) => {
      return {
        ...state,
        placementProperties: getPlacementProprties(action.payload),
      };
    });
  },
});

export const { searchPlacements } = searchSlice.actions;
export default searchSlice.reducer;
